
import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import { useTranslation } from 'react-i18next';
import CookieConsent from './components/feature/CookieConsent';
import BackToTop from './components/feature/BackToTop';

function App() {
  const { i18n } = useTranslation();

  useEffect(() => {
    // Set document direction based on language
    const direction = i18n.language === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.dir = direction;
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppRoutes />
      <CookieConsent />
      <BackToTop />
    </BrowserRouter>
  );
}

export default App;
